import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=04be1ddc"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04be1ddc')) {
      api.createRecord('04be1ddc', component.options)
    } else {
      api.reload('04be1ddc', component.options)
    }
    module.hot.accept("./Extract.vue?vue&type=template&id=04be1ddc", function () {
      api.rerender('04be1ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/Extract.vue"
export default component.exports